'use strict';

import $ from 'jquery';

export default class Accordion {
	constructor($ele) {
		this.accordion = $ele;
		this.accordionController = $('> a', this.accordion);
		this.accordionContent = $('.accordion__content', this.accordion);

		this.accordionController.on('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			this.accordion.toggleClass('open');
			this.accordionContent.slideToggle('slow');
		});

		if(this.accordionContent.hasClass('accordion__content--tooltips')){
			$('> ul > li', this.accordionContent).map((i, ele) => {
				$('.tooltip-toggle', $(ele)).on('click', (e) => {
					e.preventDefault();
	
					if(!$('.accordion__tooltip-panel', $(ele)).hasClass('active')) {
						$('.accordion__tooltip-panel', $(ele)).addClass('active');
					}
				});

				$('.accordion__tooltip-panel .panel-close', $(ele)).on('click', (e) => {
					if($('.accordion__tooltip-panel', $(ele)).hasClass('active')) {
						$('.accordion__tooltip-panel', $(ele)).removeClass('active');
					}
				});
	
				$('.accordion__tooltip-panel', $(ele)).on('click', (e) => {
					if($('.accordion__tooltip-panel', $(ele)).hasClass('active')) {
						$('.accordion__tooltip-panel', $(ele)).removeClass('active');
					}
				});
	
				$('.accordion__tooltip-panel > div', $(ele)).on('click', (e) => {
					e.stopPropagation();
				});
			});
		}
	}
}
